export const Config = {
	environment: 'production',
	sentry     : {
		dsn        : 'https://5b089b5462119289ef583a82cf216320@trace.windware.net/5',
		sample_rate: 0.1,
	},
}
